import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ProjectProfileDialog from '../../../components/dialogs/ProjectProfile';
import { getProjectProfileDialog } from '../selectors';
import { closeProjectProfileDialog } from '../actions';
import useParticipationDetails from '../../../utils/useParticipationDetails';
import useNewParticipation from '../../../utils/useNewParticipation';

const ConnectedProjectProfileDialog = ({ projectId }) => {
  const dispatch = useDispatch();
  const handleOnCancel = useCallback(() => {
    dispatch(closeProjectProfileDialog());
  }, [dispatch]);
  const options = useSelector(getProjectProfileDialog);
  const { recipientId, participationId } = options || {};

  const {
    project,
    variables,
    recipient,
    participation,
    participationDetailsReady,
  } = useParticipationDetails({
    projectId,
    recipientId,
    participationId,
  });

  const { newParticipation, newParticipationReady } =
    useNewParticipation(projectId);

  const loading =
    !options || !participationDetailsReady || !newParticipationReady;

  return (
    <ProjectProfileDialog
      project={project}
      variables={variables}
      recipient={recipient}
      participation={participation || newParticipation}
      onCancel={handleOnCancel}
      loading={loading}
      visible={!!options}
    />
  );
};

ConnectedProjectProfileDialog.propTypes = {
  projectId: PropTypes.string,
};

ConnectedProjectProfileDialog.defaultProps = {
  projectId: null,
};

export default ConnectedProjectProfileDialog;
